import { tableAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tableAnatomy.keys);

const baseStyle = definePartsStyle({
	thead: {
		color: "neutrals.900",
		boxShadow: "md",
		shadow: "md",
	},
	th: {
		fontWeight: 500,
		textTransform: "none",
		// fontSize: "24px", // Unsure why this is not taking effect.
		fontFamily: "Roboto",
	},
});

/**
 * A custom variant is required because the default background colour of the striped variant seemingly cannot be overridden.
 */
const qoriaStripedStyle = definePartsStyle(() => {
	return {
		tbody: {
			tr: {
				"&:nth-of-type(odd)": {
					bg: "neutrals.15",
				},
				"&:nth-of-type(even)": {
					bg: "white",
				},
			},
		},
	};
});

export const tableTheme = defineMultiStyleConfig({
	baseStyle: baseStyle,
	variants: {
		qoriaStriped: qoriaStripedStyle,
	},
});
